<div class="container" *ngIf="plans">
    <div class="row">
        <div class="mat-elevation-z2 rounded p-3 col-3 m-2" *ngFor="let plan of plans">
            <h1 class="text-center mb-0">{{plan.name}}</h1>

            <mat-divider class="mt-3 mb-4"></mat-divider>
            <h3 class="mt-0 text-secondary">DESCRIPTION</h3>
            <div class="d-flex justify-content-between">
                <p>{{plan.description}}</p>
            </div>
            <mat-divider class="mt-3 mb-4"></mat-divider>

            <h2><span style="font-size: xx-large;">${{plan.monthlyPricing}}</span> <span class="fw-light"
                    style="font-size: medium;"> per month</span></h2>
            <button mat-raised-button class="d-block text-center w-100" *ngIf="isPurchaseMode" (click)="onPlanSelected(plan)">
                Select
            </button>

            <mat-divider class="mt-3 mb-3"></mat-divider>

            <h3 class="mt-0 text-secondary">COSTS STRUCTURE</h3>

            <div class="d-flex justify-content-between">
                <p class="fw-bold">Minutes Included</p>
                <p>{{plan.overageLimit.toFixed(2)}} minutes included</p>
            </div>

            <div class="d-flex justify-content-between">
                <p class="fw-bold">Additional costs/min</p>
                <p>${{plan.overagePricing.toFixed(2)}}/minutes</p>
            </div>
        </div>
    </div>
</div>